import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})

/**
 * Contact Component
 */
export class ContactComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
